/* eslint-disable */
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useState, useEffect, Fragment } from 'react';
import { Modal, notification } from 'antd';
import { Helmet } from 'react-helmet';
import PhoneInput from 'react-phone-input-2';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import PinInput from 'react-pin-input';
import man from '../../assets/images/man.png';
import * as services from '../../services/schoolService';

import * as Yup from 'yup';

import Footer from '../../components/Footer/Footer';
import Button from '../../components/Button/Button';
import Verified from '../../assets/icons/Verified';
import { useNavigate } from 'react-router';

import WrongIcon from '../../assets/icons/WrongIcon';
import CheckIcon from '../../assets/icons/CheckIcon';

import Students from '../../assets/icons/Students';
import School from '../../assets/icons/School';

import { getSecurityQuestions } from '../../services/waitlistService';
import TutorAccountSetup from './TutorAccountSetup';
import Star from '../../assets/icons/Star';
import Info from '../../assets/icons/Info';
import Header from '../../components/Header/Header';
import { resendOTP } from '../../apiActions/school/useSchoolApi';
import axios from 'axios';
import { baseURL } from '../../utils/axios';
import { checkRecords } from '../../services/authService';

const ForTutors = () => {
  const navigate = useNavigate();
  const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [securityQuestions, setSecurityQuestions] = useState([]);
  const [verificationModal, setVerificationModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [setupAccountModal, setSetupAccountModal] = useState(false);
  const [successfulModal, setSuccessfulModal] = useState(false);
  const [pin, setPin] = useState('');

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    schoolName: '',
    address: '',
    password: '',
    passwordConfirmation: '',
    securityQuestion: '',
    securityAnswer: '',
    phoneNumber: '',
  };

  const handleChange = (selected) => {
    setOptionSelected(selected);
  };

  const showConfirmModal = () => {
    setConfirmModal(true);
  };

  const handleCancel = () => {
    setVerificationModal(false);
    setSuccessfulModal(false);
  };

  const handleConfirmCancel = () => {
    setConfirmModal(false);
  };

  const cancelAccountSetUp = () => {
    setSetupAccountModal(false);
  };

  const newData = JSON.parse(localStorage.getItem('school'));

  //add tutor
  const addTutor = async (schoolDetails) => {
    try {
      setLoading(true);
      let data = await services.registerSchool(schoolDetails);
      notification['success']({
        message: 'School Created Succesfully',
      });
      setLoading(false);
      setData(data.data);
      localStorage.setItem('token', data.data.accessToken);
      localStorage.setItem('verificationKey', data.data.verificationKey);
      localStorage.setItem('school', JSON.stringify(data.data));
      setVerificationModal(true);
    } catch (error) {
      let errorList =
        error.response.data.data.errors[
          Object.keys(error.response.data.data.errors)[0]
        ];
      notification['error']({
        message: errorList[0],
      });
      setLoading(false);
    }
  };

  //verify school
  const verifySchool = async () => {
    let verificationKey = localStorage.getItem('verificationKey');
    let token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    let { school } = JSON.parse(localStorage.getItem('school'));
    let id = school.id;
    let apiData = {
      verificationKey,
      OTP: pin,
    };
    try {
      setLoading(true);
      await axios.put(`${baseURL}/schools/${id}/verify`, apiData, {
        headers: headers,
      });
      notification['success']({
        message: 'Verification Succesful',
      });
      setLoading(false);
      showConfirmModal();
      handleCancel();
    } catch (error) {
      notification['error']({
        message: error.response.data.message,
      });
      setLoading(false);
    }
  };

  //get security questions on mount
  useEffect(() => {
    async function fetchQuestions() {
      try {
        let res = await getSecurityQuestions();
        setSecurityQuestions(res.data.securityQuestions);
      } catch (error) {
        console.log(error);
      }
    }
    fetchQuestions();
  }, []);

  const handlePinChange = (value) => {
    setPin(value);
  };

  const validateRecords = async (data) => {
    try {
      let res = await checkRecords(data);
      return res?.message;
    } catch (error) {
      notification['error']({
        message: error.response.data.data.errors.schoolName[0],
      });
    }
  };

  return (
    <div>
      <Helmet>
        <title>PL by Edves | For Tutors</title>
      </Helmet>
      <Header />

      <div className='login'>
        <div className='login__heading'>
          <h2>Great to have you onboard</h2>
          <p>Enter your account details correctly to get started</p>
        </div>

        <div className='user-selection'>
          <div className='user-selection__wrapper'>
            <div
              className={`user-selection__wrapper__selection ${
                window.location.pathname === '/student-signup'
                  ? 'selected-user'
                  : ''
              } `}
              onClick={() => navigate('/student-signup')}
            >
              <Students />
              <p>Student</p>
            </div>

            <div className='user-selection__wrapper__vertical-border'></div>
            <div
              className={`user-selection__wrapper__selection ${
                window.location.pathname === '/school-register'
                  ? 'selected-user'
                  : ''
              } `}
            >
              <School />
              <p>School / Tutor</p>
            </div>
          </div>
        </div>

        <div
          className='login__form'
          style={{ marginBottom: '24px' }}
          // onClick={() => setShowDropdown(false)}
        >
          <div className='auth-wrapper__right__form'>
            <Formik
              initialValues={initialValues}
              validationSchema={Yup.object({
                firstName: Yup.string()
                  .required('Field cannot be empty')
                  .min(2),
                lastName: Yup.string().required('Field cannot be empty').min(2),
                schoolName: Yup.string()
                  .required('Field cannot be empty')
                  .min(2),
                address: Yup.string().required('Field cannot be empty').min(5),
                phoneNumber: Yup.string().required('Field cannot be empty'),
                password: Yup.string()
                  .required('Field cannot be empty')
                  .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/,
                    'Must contain 8 characters, One Uppercase, One Lowercase and One Number'
                  ),
                passwordConfirmation: Yup.string()
                  .oneOf([Yup.ref('password'), null], `Password doesn't match`)
                  .required('You need to confirm password'),

                securityQuestion: Yup.string().required(
                  'Field cannot be empty'
                ),
                email: Yup.string()
                  .required('Field cannot be empty')
                  .matches(emailReg, 'Invalid Email'),
                securityAnswer: Yup.string().required('Field cannot be empty'),
              })}
              onSubmit={async (values, { setSubmitting, resetForm }) => {
                setSubmitting(false);
                const data = {
                  ...values,
                };
                let res = await validateRecords(data);
                if (res === 'All records supplied do not exist') {
                  addTutor(data, resetForm);
                } else {
                  return;
                }
              }}
            >
              {({
                setFieldValue,
                errors,
                touched,
                isValid,
                dirty,
                isSubmitting,
              }) => (
                <Form>
                  <div>
                    <div className='flex-to-column'>
                      <div
                        className='auth-wrapper__right__form__inputwrapper eye-position'
                        style={{ width: '100%' }}
                      >
                        <label htmlFor='firstName'>First name</label>

                        <Field
                          type='text'
                          name='firstName'
                          id='firstName'
                          placeholder='Enter your first name'
                          className={
                            touched.firstName && errors.firstName
                              ? 'input-error'
                              : ''
                          }
                        />
                        <div className='eye-icon'>
                          {touched.firstName ? (
                            errors.firstName ? (
                              <WrongIcon />
                            ) : (
                              <CheckIcon />
                            )
                          ) : (
                            ''
                          )}
                        </div>
                      </div>

                      <div
                        className='auth-wrapper__right__form__inputwrapper eye-position'
                        style={{ width: '100%' }}
                      >
                        <label htmlFor='lastName'>Last name</label>

                        <Field
                          type='text'
                          name='lastName'
                          id='lastName'
                          placeholder='Enter your last name'
                          className={
                            touched.lastName && errors.lastName
                              ? 'input-error'
                              : ''
                          }
                        />

                        <div className='eye-icon'>
                          {touched.lastName ? (
                            errors.lastName ? (
                              <WrongIcon />
                            ) : (
                              <CheckIcon />
                            )
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className='auth-wrapper__right__form__inputwrapper eye-position'
                      style={{ width: '100%' }}
                    >
                      <label htmlFor='schoolName'>
                        School name (this will be used as your PL unique link)
                      </label>

                      <Field
                        type='text'
                        name='schoolName'
                        id='schoolName'
                        placeholder='Enter your school name'
                        className={
                          touched.schoolName && errors.schoolName
                            ? 'input-error'
                            : ''
                        }
                      />

                      <div className='eye-icon'>
                        {touched.schoolName ? (
                          errors.schoolName ? (
                            <WrongIcon />
                          ) : (
                            <CheckIcon />
                          )
                        ) : (
                          ''
                        )}
                      </div>
                    </div>

                    <div className='auth-wrapper__right__form__inputwrapper eye-position'>
                      <label htmlFor='email-address'>
                        School email address
                      </label>

                      <Field
                        type='email'
                        name='email'
                        id='email-address'
                        placeholder='Enter Email Address'
                        className={
                          touched.email
                            ? errors.email
                              ? 'input-error'
                              : ''
                            : ''
                        }
                      />
                      <div className='eye-icon'>
                        {touched.email ? (
                          errors.email ? (
                            <WrongIcon />
                          ) : (
                            <CheckIcon />
                          )
                        ) : (
                          ''
                        )}
                      </div>
                    </div>

                    <div
                      className='auth-wrapper__right__form__inputwrapper'
                      style={{ marginBottom: '32px' }}
                    >
                      <label htmlFor='email'>Phone Number</label>

                      <PhoneInput
                        country={'ng'}
                        name='phoneNumber'
                        // onChange={(val) => setFieldValue("phone", val)}
                        onChange={(value) => {
                          setFieldValue('phoneNumber', value);
                        }}
                      />
                    </div>

                    <div
                      className='auth-wrapper__right__form__inputwrapper eye-position'
                      style={{ width: '100%' }}
                    >
                      <label htmlFor='address'>Address</label>

                      <Field
                        type='text'
                        name='address'
                        id='address'
                        placeholder='Enter your school main address'
                        className={
                          touched.address && errors.address ? 'input-error' : ''
                        }
                      />

                      <div className='eye-icon'>
                        {touched.address ? (
                          errors.address ? (
                            <WrongIcon />
                          ) : (
                            <CheckIcon />
                          )
                        ) : (
                          ''
                        )}
                      </div>
                    </div>

                    <div className='auth-wrapper__right__form__inputwrapper'>
                      <label htmlFor='securityQuestion '>
                        Security Question <Info />
                      </label>
                      <div className='auth-wrapper__right__form__selectwrapper'>
                        <Field
                          as='select'
                          name='securityQuestion'
                          id='question'
                        >
                          <option value=''>Select security question</option>
                          {securityQuestions.length > 0 &&
                            securityQuestions.map((el) => (
                              <Fragment key={el.id}>
                                <option value={el.id}>{el.title}</option>
                              </Fragment>
                            ))}
                        </Field>
                      </div>
                    </div>

                    <div className='auth-wrapper__right__form__inputwrapper eye-position'>
                      <label htmlFor='securityAnswer'>Answer</label>

                      <Field
                        type='text'
                        name='securityAnswer'
                        id='securityAnswer'
                        placeholder='Enter your answer here'
                        className={
                          touched.securityAnswer
                            ? errors.securityAnswer
                              ? 'input-error'
                              : ''
                            : ''
                        }
                      />

                      <div className='eye-icon'>
                        <div>
                          {touched.securityAnswer ? (
                            errors.securityAnswer ? (
                              <WrongIcon />
                            ) : (
                              <CheckIcon />
                            )
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className='auth-wrapper__right__form__passwordwrapper eye-position'
                      style={{ marginBottom: '10px' }}
                    >
                      <label htmlFor='password'>Password</label>

                      <Field
                        type={showPassword ? 'text' : 'password'}
                        name='password'
                        id='password'
                        placeholder='Enter your password'
                        className={
                          touched.password
                            ? errors.password
                              ? 'input-error'
                              : ''
                            : ''
                        }
                      />

                      <div className='eye-icon gap-8'>
                        <div>
                          {touched.password ? (
                            errors.password ? (
                              <WrongIcon />
                            ) : (
                              <CheckIcon />
                            )
                          ) : (
                            ''
                          )}
                        </div>

                        <div onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? (
                            <AiOutlineEyeInvisible />
                          ) : (
                            <AiOutlineEye />
                          )}
                        </div>
                      </div>
                    </div>

                    {touched.password ? (
                      errors.password ? (
                        <p className='password-error'>
                          <ErrorMessage name='password'>
                            {(msg) => msg}
                          </ErrorMessage>
                        </p>
                      ) : (
                        ''
                      )
                    ) : (
                      ''
                    )}

                    <div
                      className='auth-wrapper__right__form__inputwrapper eye-position'
                      style={{ marginBottom: '16px' }}
                    >
                      <label htmlFor='passwordConfirmation'>
                        Confirm Password
                      </label>

                      <Field
                        type={showConfirmPassword ? 'text' : 'password'}
                        name='passwordConfirmation'
                        id='passwordConfirmation'
                        placeholder='Re-enter your password'
                        className={
                          touched.passwordConfirmation
                            ? errors.passwordConfirmation
                              ? 'input-error'
                              : ''
                            : ''
                        }
                      />

                      <div className='eye-icon gap-8'>
                        <div>
                          {touched.passwordConfirmation ? (
                            errors.passwordConfirmation ? (
                              <WrongIcon />
                            ) : (
                              <CheckIcon />
                            )
                          ) : (
                            ''
                          )}
                        </div>
                        <div
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? (
                            <AiOutlineEyeInvisible />
                          ) : (
                            <AiOutlineEye />
                          )}
                        </div>
                      </div>
                    </div>
                    {touched.passwordConfirmation ? (
                      errors.passwordConfirmation ? (
                        <p className='password-error'>
                          Password does not match
                        </p>
                      ) : (
                        ''
                      )
                    ) : (
                      ''
                    )}
                    <div style={{ marginTop: '32px' }}>
                      <Button
                        text={
                          loading ? 'Please wait...' : 'Sign Up as an educator'
                        }
                        className='primary-btn'
                        type='submit'
                        width='100%'
                        disabled={isSubmitting || !dirty || !isValid || loading}
                      />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <div className='new-user' style={{ marginBottom: '79px' }}>
          <p>Already a registered user?</p>
          <p className='new-user__second' onClick={() => navigate('/login')}>
            Log in to your account here
          </p>
        </div>
      </div>

      <Footer />

      <Modal
        width={606}
        visible={verificationModal}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
      >
        <div style={{ padding: '40px' }}>
          <div className='modal-head' style={{ marginBottom: '24px' }}>
            <div className='confirm-icon-wrapper'>
              <Verified />
            </div>
            <h2>Verify account</h2>
            <p>
              We have sent a 4- digit verification code to the email address you
              provided; <b>{data?.admin?.email}</b>. Kindly input the code below
              to verify your account
            </p>
          </div>
          <div className='center' style={{ marginBottom: '24px' }}>
            <PinInput
              length={4}
              initialValue=''
              secret
              onChange={handlePinChange}
              type='numeric'
              inputMode='number'
              style={{ padding: '10px' }}
              inputStyle={{
                borderColor: '#F1F1F1',
                background: ' #FCFCFC',
                borderRadius: '4px',
                marginRight: '24px',
                width: '60px',
                height: '60px',
              }}
              inputFocusStyle={{ borderColor: '#F1F1F1' }}
              onComplete={(value, index) => {}}
              autoSelect={true}
              regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
            />
          </div>
          <div className='new-user center' style={{ marginBottom: '79px' }}>
            <p>Didn't receive a code?</p>
            <p
              className='new-user__second'
              onClick={() => {
                resendOTP();
              }}
            >
              Resend
            </p>
          </div>

          <Button
            disabled={!pin || pin.length < 4}
            text={loading ? 'Verifying...' : 'Verify Account'}
            className='primary-btn'
            width='100%'
            onClick={() => {
              verifySchool();
            }}
          />
        </div>
      </Modal>
      <Modal
        width={606}
        visible={confirmModal}
        onOk={handleConfirmCancel}
        onCancel={handleConfirmCancel}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
      >
        <div style={{ padding: '40px' }}>
          <div className='selected-school-reg__title'>
            <p>Welcome to</p>
            <h2>PL by Edves</h2>
          </div>
          <img src={man} alt='' />
          <div className='selected-school-reg__body'>
            <div className='selected-school-reg__body__story-2'>
              <p>
                <b style={{ color: '#FEA82F', marginRight: '6px' }}>
                  {' '}
                  Hello {newData?.school?.name || ''}!
                </b>{' '}
                Thank you for partnering with us to not only impact knowledge
                but to inspire change in the academic pursuit of learners.
              </p>
              <p style={{ marginTop: '12px' }}>
                Before we start showing you around, let’s setup your account. We
                want to create the best experience for you and provide a
                seamless navigation as you begin inviting your teachers,
                creating learning contents, and managing all activities.
              </p>
            </div>
          </div>
        </div>

        <div
          style={{
            paddingBottom: '41px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button
            className='primary-btn'
            text={loading ? 'Please wait...' : "Let's go!"}
            disabled={loading}
            onClick={() => {
              handleConfirmCancel();
              setSetupAccountModal(true);
            }}
          />
        </div>
      </Modal>
      <Modal
        width={606}
        visible={setupAccountModal}
        onOk={cancelAccountSetUp}
        onCancel={cancelAccountSetUp}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
      >
        <TutorAccountSetup
          setSuccessfulModal={setSuccessfulModal}
          cancelAccountSetUp={cancelAccountSetUp}
        />
      </Modal>

      <Modal
        width={606}
        visible={successfulModal}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        footer={null}
        keyboard={false}
        maskClosable={false}
      >
        <div className='modal-padding'>
          <div className='modal-head' style={{ marginBottom: '32px' }}>
            <div className='confirm-icon-wrapper'>
              <Star />
            </div>
            <h2>Acccount setup successful!</h2>
            <p>
              Yayy! You have successfully setup your account, now you can start
              creating engaging learning resources with the tools we have made
              available to you on your dashboard.
            </p>
          </div>
          <Button
            text={'Go to dashboard'}
            className='primary-btn'
            width='100%'
            onClick={() => {
              handleCancel();
              navigate('/login');
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ForTutors;
